import { Navigate } from 'react-router'

import { ProductLoadingPage, useProductShell } from '@/components/sidebar'
import { PageSpinner } from '@/components/ui/PageSpinner'
import { landsOnApplication, showsQuotesPage, useCurrentUser, type User } from '../models/user'

/** Sends whoever lands on /insure to their page. PrivateLayout, around it, has signed them in. */
export function IndexRedirect() {
  const { user, isLoading } = useCurrentUser({ enabled: true })
  // In the shared shell the console is a tab of its own, so Insurance is always the customer's side.
  const shell = useProductShell()

  if (isLoading || !user) {
    return shell ? <ProductLoadingPage /> : <PageSpinner />
  }

  const target = landingPath(user, !!shell)
  // In the shared shell the page stays a skeleton while the router moves on, rather than going blank.
  return (
    <>
      <Navigate to={target} replace />
      {shell && <ProductLoadingPage path={target} />}
    </>
  )
}

/** Where /insure sends this user. */
function landingPath(user: User, inShell: boolean): string {
  // Every pre-coverage status lands on the application; non-admins bounce off it to Insurance.
  if (landsOnApplication(user.currentOrg) && !user.isStaff) {
    const org = user.currentOrg
    return showsQuotesPage(org, org.currentInsuranceApplication) ? '/quotes' : '/application'
  }

  // Cai admins always land on the Console's customers list. This deliberately
  // ignores the sidebar's App/Console toggle: that preference controls which
  // links the sidebar shows, and letting it also decide the landing page meant
  // one visit to the App view permanently sent staff to the customer side.
  if (user.isCaiAdmin && !inShell) return '/insure/internal/customers'

  return '/insure/insurance'
}
